export const testFlag =
  window.location.host.includes('test') ||
  window.location.host.includes('localhost');
export const BaseUrl = testFlag
  ? 'https://test-play.sallochat.com'
  : 'https://play.yoometapp.com'; //pro
export const ImgBaseUrl = testFlag
  ? 'https://test-img.sallochat.com'
  : 'https://img.yoometapp.com'; //pro
export const WebUrl = testFlag
  ? 'https://test-www.sallochat.com'
  : 'https://www.yoometapp.com'; //pro
export const SignatureKey = testFlag ? 'W5Y2qfRCXJw6MXP7' : 'W1bctaVidKfpcxbQ'; //pro
export const DecodeKey = testFlag ? 'SVZeNfzZN3EQcUtQ' : 'IImtpZCI6IUwM2E1'; //pro
export const ZegoAppId = testFlag ? 673933163 : 834597803; //pro
export const ReportSDK = testFlag
  ? '//webtracksdk-test.stnts.com/websdkv2.4.test.js'
  : '//dtsdk.sallochat.com/websdkv2.4.js'; //pro
export const ReportDes = testFlag ? void 0 : '//dssp.sallochat.com'; //pro
export const IMConfig = {
  appkey: testFlag
    ? '4c8b36a496a79f5d19e9ffeeb89e4ec7'
    : '7f0f8b104b54639d756aaa041359497c', //pro
  debugLevel: 'warn',
  apiVersion: 'v2',
};
export const GoogleAuthClientId =
  '671980133687-s4a5icivmrk6u3ug3s9khq9uvghcemv7.apps.googleusercontent.com';
export const DecodePrefix = 'DAIDAI-';
export const RequestBaseSignature = {
  source: 1,
  vnum: '1',
  companyCode: 'SC_301',
  appCode: 'SC_302',
};
export const RequestHeaderExts = {
  appSubCode: 'YOOMET',
  version: '1.0.0',
};
export const NSFWBlackList = ['99999'];

export const DefaultChannel = 'PIDUDicBjEaa';
export const ChannelCacheKey = '_scck';
export const NsfwFlag = '_nsfw';
export const AuthCacheKey = '_sack';
export const AuthIdCacheKey = '_saick';
export const UCUidCacheKey = '_suuck';
export const LangCacheKey = '_slck';
export const NSFWCacheKey = '_snck';
export const ProductId = 320008;

export const BingKeyWord = '_bing_keyword';
export const BingMsclkid = '_bing_msclkid';
export const BingMsclkidCreationTime = '_bing_msclkid_creationTime';
export const BingQuery = '_bing_query';

export const GoogleGclid = '_gclid';
export const GoogleGclidCreationTime = '_gclid_creationTime';
export const GoogleKeyword = '_ggkeyword';
export const GoogleMatchType = '_ggmatchtype';

export const UuidKey = '_uuid';
